exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.emphasis[data-v-38917616]{color:#22252C;font-weight:bolder\n}\n", ""]);

// exports
